import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const tabs = [
  { name: 'About', path: '/' },
  { name: 'Journeys', path: '/journeys' },
  { name: 'Music', path: '/music' },
  { name: 'Comedy', path: '/comedy' },
  { name: 'Podcast', path: '/podcast' },
];

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  
  return (
    <div className="min-h-screen flex flex-col bg-light-gray">
      <header className="py-4 px-6 md:px-12 bg-white sticky top-0 z-10 shadow-sm">
        <div className="container max-w-content mx-auto">
          <div className="flex items-center justify-between">
            <Link to="/" className="text-xl font-bold text-black">
              RANDM
            </Link>
            <nav className="flex space-x-6">
              {tabs.map((tab) => (
                <Link
                  key={tab.path}
                  to={tab.path}
                  className={`py-2 text-base font-medium ${
                    location.pathname === tab.path
                      ? 'text-black border-b-2 border-black'
                      : 'text-dark-gray hover:text-black'
                  }`}
                >
                  {tab.name}
                </Link>
              ))}
            </nav>
            <Link 
              to="/contact" 
              className="py-2 px-4 border border-black text-sm font-medium hover:bg-black hover:text-white transition-colors"
            >
              Let's Talk
            </Link>
          </div>
        </div>
      </header>
      
      <main className="flex-grow">
        {children}
      </main>
      
      <footer className="py-12 px-6 md:px-12 bg-white border-t border-gray-200">
        <div className="container max-w-content mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="md:col-span-1">
              <Link to="/" className="text-xl font-bold text-black mb-4 inline-block">
                RANDM
              </Link>
              <p className="text-dark-gray">
                A dual-portfolio of diverse and experimental projects by Roscoe and Matthew.
              </p>
            </div>
            <div>
              <h3 className="font-medium mb-4">Navigation</h3>
              <ul className="space-y-2">
                {tabs.map((tab) => (
                  <li key={tab.path}>
                    <Link 
                      to={tab.path}
                      className="text-dark-gray hover:text-black transition-colors"
                    >
                      {tab.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className="font-medium mb-4">Connect</h3>
              <ul className="space-y-2">
                <li><a href="https://instagram.com" className="text-dark-gray hover:text-black transition-colors">Instagram</a></li>
                <li><a href="https://twitter.com" className="text-dark-gray hover:text-black transition-colors">Twitter</a></li>
                <li><a href="https://linkedin.com" className="text-dark-gray hover:text-black transition-colors">LinkedIn</a></li>
              </ul>
            </div>
            <div>
              <h3 className="font-medium mb-4">Contact</h3>
              <ul className="space-y-2">
                <li><a href="mailto:contact@randm.com" className="text-dark-gray hover:text-black transition-colors">contact@randm.com</a></li>
              </ul>
            </div>
          </div>
          <div className="mt-12 pt-6 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center">
            <div className="text-sm text-dark-gray">
              © {new Date().getFullYear()} RANDM. All rights reserved.
            </div>
            <div className="mt-4 md:mt-0 text-sm text-dark-gray">
              Designed & Developed with ♥
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout; 